export default defineNuxtPlugin((nuxtApp) => {
  if (!import.meta.client || !import.meta.dev) return;

  const base = useRuntimeConfig().app.baseURL || '/';
  const url = `${base.endsWith('/') ? base : `${base}/`}api/dev/boot-error`;

  const send = (err: unknown, extra: string) => {
    const message = err instanceof Error ? err.message : String(err);
    const stack = err instanceof Error ? err.stack : '';
    try {
      void fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ extra, message, stack, href: window.location.href }),
      });
    }
    catch {
      // ignore
    }
    console.error('[picker boot]', extra, err);
  };

  window.addEventListener('error', event => send(event.error || event.message, 'window.error'));
  window.addEventListener('unhandledrejection', event => send(event.reason, 'unhandledrejection'));
  nuxtApp.hook('vue:error', (err, _instance, info) => send(err, `vue:error ${info}`));
  nuxtApp.hook('app:error', err => send(err, 'app:error'));
});
